require('./wizardError.scss');
const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const classnames = require('classnames');

class WizardError extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { errorMessage, errorSubMessage, icon } = this.props;
        const classNames = classnames('wizard-error-step');

        return (
            <div className={classNames}>
                <div className="wizard-error-step__highlight">
                    <i
                        className={`wizard-error-step__icon wizard-error-step__${icon}-icon`}
                    ></i>
                    <div className="wizard-error-step__messages">
                        {errorMessage}
                        <div className="wizard-error-step__error-sub-message">
                            {errorSubMessage}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

WizardError.defaultProps = {
    secondaryButton: {},
    categoryError: '',
    customClassName: '',
    descriptionError: '',
    icon: 'error',
};

WizardError.propTypes = {
    categoryError: PropTypes.string,
    descriptionError: PropTypes.string,
    errorMessage: PropTypes.string,
    icon: PropTypes.string,
    errorSubMessage: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

module.exports = WizardError;
